import {
  BaseService,
  Status,
  DataResponse,
  MessageResponse,
  MessageData,
} from './base.service';
import { Media } from '@/models/media.model';

class MediaService extends BaseService {
  private url: string = '/api/media';

  constructor() {
    super();
  }

  public async get(id: number): Promise<DataResponse<Media>> {
    const res = await this.$http.get<Media>(`${this.url}/id/${id}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async search(search: string): Promise<DataResponse<Media[]>> {
    const res = await this.$http.get<Media[]>(`${this.url}/search/${search}`);
    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async upload(
    media: Media,
    uuid?: string,
  ): Promise<DataResponse<Media | null>> {
    if (media.file) {
      const data = new FormData();
      data.append('file', media.file);
      data.append('language', media.language || '');
      data.append('purpose', media.purpose);
      data.append('description', media.description);

      const res = await this.$http.post<Media>(
        `${this.url}/upload`,
        data,
        true,
        uuid
          ? {
              uuid,
            }
          : {},
      );

      return {
        status: [Status.Ok, Status.Created].includes(res.status),
        data: res.data,
      };
    }
    return {
      status: false,
      data: null,
    };
  }

  public async add(media: Media, uuid?: string): Promise<DataResponse<Media>> {
    const res = await this.$http.post<Media>(
      `${this.url}/add`,
      media,
      undefined,
      uuid
        ? {
            uuid,
          }
        : {},
    );

    return {
      status: [Status.Ok, Status.Created].includes(res.status),
      data: res.data,
    };
  }

  public async edit(media: Media, uuid?: string): Promise<DataResponse<Media>> {
    const res = await this.$http.put<Media>(
      `${this.url}/${media.id}`,
      media,
      undefined,
      uuid
        ? {
            uuid,
          }
        : {},
    );

    return {
      status: res.status === Status.Ok,
      data: res.data,
    };
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new MediaService();
